import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Label, PostLabel, PutLabel } from 'src/app/interfaces/api/label';
import { environment } from 'src/environments/environment';
import { ApiService } from '../../core/api.service';
import { LocalStorageService } from './../../core/local-storage.service';

type QueryParams = Record<string, string | number | boolean | Date | Array<string | number | boolean | Date> | object>;

@Injectable({
  providedIn: 'root'
})

export class LabelService {

  collection = "Label";
  collectionPath = "labels";
  labels: Label[] = [];
  apiUrl = environment.API_URL;

  constructor(
    private apiService: ApiService,
    private localStorage: LocalStorageService
  ) {
  }

  //---GET---//

  getLabels(query: QueryParams): Observable<Label[]> {
    return this.apiService.getCollection(this.collectionPath, "", query);
  }

  getLabelByLabelProject(name: string, key: string | null = null): Observable<Label[]> {
    return this.apiService.getCollectionItem(this.collectionPath, "", name);
  }

  searchLabels(search: string, query: QueryParams = {}): Observable<Label[]> {
    return this.apiService.getCollection(this.collectionPath, 'search', { q: search, ...query });
  }

  getLabelsCount(project: string = "", query: QueryParams = {}): Observable<number> {
    return this.apiService.getCollection(this.collectionPath, 'count', { project, ...query });
  }

  labelExists(query: QueryParams): Observable<boolean> {
    return this.apiService.getCollection(this.collectionPath, "exists", query);
  }


  //---POST---//

  addLabel(label: PostLabel): Observable<any> {
    return this.apiService.postCollectionData(this.collectionPath, "", label);
  }

  //---PUT---//

  setLabels(payload: { project: string, labels: PutLabel[]}): Observable<any> {
    return this.apiService.updateCollection(this.collectionPath, "", payload);
  }

  setLabel(label: PutLabel): Observable<any> {
    return this.apiService.updateCollectionItem(this.collectionPath, label);
  }

  //---DELETE---//

  deleteLabel(id: string): Observable<any> {
    return this.apiService.deleteCollectionItem(this.collectionPath, id);
  }
}
